<template>
  <v-container>
    <v-layout text-center wrap>
      <v-row no-gutters>
        <v-col cols="12">
          <v-card flat>
            <v-card-text>
              <v-tabs fixed-tabs background-color="indigo" dark>
                <v-tab @click="activeTab('import')">Imports</v-tab>
                <v-tab @click="activeTab('export')">Exports</v-tab>
                <v-tab-item>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12">
                        <manifest />
                        <!-- <v-tabs
                          background-color="white"
                          color="deep-purple accent-4"
                          left
                        >
                          <v-tab>Manifest</v-tab>
                          <v-tab>Dashboard</v-tab>
                          <v-tab>Reporting</v-tab>
                          <v-tab-item>
                            <v-container fluid>
                              <v-row>
                                <v-col cols="12">
                                  <manifest />
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-tab-item>

                          <v-tab-item>
                            <v-container fluid>
                              <v-row no-gutters>
                                Dashboard
                              </v-row>
                            </v-container>
                          </v-tab-item>
                          <v-tab-item>
                            <v-container fluid>
                              <v-row no-gutters>
                                <report-options />
                              </v-row>
                            </v-container>
                          </v-tab-item>
                        </v-tabs> -->
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>

                <v-tab-item>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12">
                        <manifest />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
              </v-tabs>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</template>
<script>
import Manifest from "@/components/Manifest";
//import ReportOptions from "@/components/ReportOptions";
import { EventBus } from "../main";

export default {
  components: {
    Manifest,
    //ReportOptions
  },

  // created() {
  //   this.setActiveTab("import");
  // },

  methods: {
    activeTab(tab) {
      this.setActiveTab(tab);
    },
    setActiveTab(tab) {
      EventBus.$emit("selectedManifestTab", tab);
    }
  }
};
</script>
<style scoped></style>
